import CalEmbed from '../components/CalEmbed';
import '../styles/page-book-demo.css';
import Seo from '../components/Seo';

/* Demos are booked through Cal.com, exactly as on the live site — real
   availability, timezone handling, calendar invites, reschedule and cancel
   links. An earlier version of this page posted a form to /api/v1/contact,
   which is not how the product books demos: no page on the live site sends
   that payload, so those requests would have gone nowhere useful. */

const POINTS = [
  'Pattern Intelligence & the Anomaly Feed, live',
  'Ask TeamGrid answering real questions',
  'Privacy model: patterns, not people',
  'Rollout plan for 10 → 10,000 computers',
];

const Check = () => (
  <svg aria-hidden="true" className="chk" viewBox="0 0 16 16" style={{ width: '15px', height: '15px', flex: '0 0 auto', marginTop: '4px' }}>
    <path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" />
  </svg>
);

export default function BookDemoPage() {
  return (
    <>
      <Seo title="Book a Demo — 20 minutes, zero slides | TeamGrid™" description="Book a 20-minute walkthrough on live demo data. See Pattern Intelligence, the Anomaly Feed and Ask TeamGrid answer your hardest question. No slides." />
      <header className="f-hero">
        <div className="container">
          <div className="f-grid">
            <div>
              <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />20 minutes, zero slides <span className="arr">›</span></span>
              <h1 style={{ fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', margin: '20px 0 14px' }}>
                See your org<br /><span style={{ color: '#a9aab3' }}>through the brain</span>
              </h1>
              <p style={{ fontSize: '15.5px', lineHeight: '24px', color: 'var(--ink-soft)', marginBottom: '22px' }}>
                A live walkthrough on real (demo) data — not a deck. Bring your hardest question about your teams; we’ll show you how TeamGrid answers it.
              </p>
              <ul style={{ display: 'flex', flexDirection: 'column', gap: '11px' }}>
                {POINTS.map((p) => (
                  <li key={p} style={{ display: 'flex', gap: '10px', fontSize: '14.5px', fontWeight: '600', color: 'var(--ink-strong)' }}>
                    <Check /><span>{p}</span>
                  </li>
                ))}
              </ul>
              <p style={{ fontSize: '13px', lineHeight: '21px', color: 'var(--ink-soft)', marginTop: '22px' }}>
                Pick any slot that suits you — the calendar shows live availability in your own timezone,
                and the invite lands in your inbox straight away.
              </p>
            </div>

            <div>
              <CalEmbed height={680} />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
